<template>
  <div>
    <Filters v-model="filterData" :loading="loading" :catalogs="catalogs" @input="submitSearch" />
    <CatalogTable
      ref="table"
      :table-data="fetchedData"
      :pagination-info="paginationInfo"
      :tableHeaders="headers"
      :tableFilters="filters"
      :loading="loading"
      :loading-content-props="loadingProps"
      :dummy-search="true"
      :page-size="currentPageSize"
      @pageUpdated="currentPage = $event"
      @updatedSearchQuery="filterData.searchQuery = $event"
      @updatedPageSize="currentPageSize = $event"
    >
      <div slot="sinisterNumber-cell" slot-scope="{ item }">
        <button class="btn-link" @click="goToSinisterFile(item)">{{ item.sinisterNumber }}</button>
        <md-tooltip md-direction="top">Ir a ficha</md-tooltip>
      </div>
      <div slot="exe-cell">
        <div v-for="(action, index) in actions.filter((a) => a.ifUserCan)" :key="index">
          <md-button class="md-just-icon md-simple md-info" @click="action.exe">
            <md-icon>{{ action.icon }}</md-icon>
          </md-button>
          <md-tooltip md-direction="top">{{ action.tooltip }}</md-tooltip>
        </div>
      </div>
    </CatalogTable>
  </div>
</template>

<script>
// COMPONENTS
import { CatalogTable, FileField } from "@/components/";
import Filters from "./Filter";
import SinisterInfo from "@/pages/RoadSinisters/File/ConceptsValidation/SinisterInfo";

// SERVICES
import catalogService from "@/services/catalog";
import sinisterService from "@/services/sinister";

// UTILS
import { downloadFile } from "@/utils";
import { mapPermissions } from "@/plugins/accountPermissions";
import moment from "moment";

import { debounce } from "lodash";

const DEFAUL_SEARCH_PARAMS = {
  dateFrom: moment().subtract(15, "days").format("YYYY-MM-DD"),
  dateTo: moment().format("YYYY-MM-DD"),
  searchQueryquery: "",
  provider: null,
};

export default {
  name: "AccountProvidersReportIndex",
  components: {
    CatalogTable,
    Filters,
    SinisterInfo,
    FileField,
  },

  data() {
    return {
      filterData: DEFAUL_SEARCH_PARAMS,
      catalogs: {
        providers: [],
      },
      currentPage: 1,
      currentPageSize: 10,
      paginationInfo: null,
      loading: true,

      fetchedData: [],
      currentSinister: {},
      headers: {
        sinisterNumber: "Siniestro",
        affectedRequisitionNumber: "Requisición",
        highway: "Autopista",
        tramo: "Tramo",
        ammount: "Devolución por sobrante",
        exe: "Acciones",
      },
      filters: {
        // folioJB: (folio) => (folio && folio) || "Sin folio",
      },
      // searchableProps: ["sinisterNumber"],
      actions: [
        // {
        //   icon: "edit",
        //   exe: this.editRoadSinister,
        //   ifUserCan: {
        //     change: "Roads/sinisterroads",
        //   },
        //   tooltip: "Editar siniestro",
        // },
      ],
      loadingProps: {
        emptyLabel: "No hay ordenes que mostrar",
        emptyDescription:
          "Procure seleccionar un proveedor o inténtelo más tarde",
      },
    };
  },

  computed: {
    ...mapPermissions("Roads", "sinisterroads"),
  },

  watch: {
    "paginationInfo.previous": function (value) {
      this.currentPage = (value || 0) + 1;
    },
    currentPageSize() {
      this.currentPage = 1;
    },
    paginationInfo(value) {
      this.$emit("update:paginationInfo", value);
    },
  },

  methods: {
    submitSearch(params) {
      if (params.provider) {
        this.currentPage = 1;
        let dFrom = moment(params.dateFrom);
        let dTo = moment(params.dateTo);

        if (dFrom.isSameOrBefore(dTo, "day")) {
          this.debouncedFetch(this.fetchData, params);
        } else {
          this.$notify({
            message: "Rango de fechas incorrecto",
            icon: "close",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        }
      }
    },
    goToSinisterFile(roadSinister) {
      const routeData = this.$router.resolve({
        name: "Ficha de Siniestro Carretero",
        params: {
          id: roadSinister.id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    fetchData() {
      this.loading = true;
      this.fetchedData = [];
      return sinisterService
        .fetch(this.fetchParams)
        .then(({ sinisters, paginationInfo }) => {
          this.fetchedData = sinisters;
          this.paginationInfo = paginationInfo;
        })
        .catch(this.$fireErrorResponse)
        .finally(() => (this.loading = false));
    },
    downloadReport() {
      const {
        from: fromP,
        to: toP,
        highway,
        job: sinisterType,
      } = this.filtersParams;
      const from = fromP ? moment(fromP).format("YYYY-MM-DD") : undefined;
      const to = toP ? moment(toP).format("YYYY-MM-DD") : undefined;
      const highways =
        highway && highway.length ? highway.join(",") : undefined;
      downloadFile("sinisters/sinister_download_report/", "reporte.xls", {
        config: {
          params: {
            type: "xls",
            fromDate: from,
            toDate: to,
            highway: highways,
            sinisterType: sinisterType ? sinisterType : undefined,
          },
        },
      })
        .then(() => {
          this.$notify({
            message: "Descargando archivo.",
            icon: "close",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch(this.$fireErrorResponse);
    },
    // seeFile(file) {
    //   const win = window.open(file, "_blank");
    //   win.focus();
    // },
  },
  mounted() {
    Promise.all([catalogService.fetch("providers")])
      .then(([providers]) => {
        this.catalogs.providers = providers;
      })
      .catch(this.$fireErrorResponse)
      .finally(() => (this.loading = false));

    this.debouncedFetch = debounce((callback, ...args) => {
      callback(args);
    }, 500);
  },
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Providers/AccountReport/index.vue